import { fieldsCommonOptions } from "@garantidos/data"

const {
  NATIONALITY_OPTIONS,
  UF_OPTIONS,
  FULL_MARITAL_STATUS_OPTIONS,
  OCCUPATION_OPTIONS
} = fieldsCommonOptions

const OCCUPATION_CATEGORY_OPTIONS = [
  {
    label: "Assalariado(a)",
    value: "ASSALARIADO"
  },
  {
    label: "Aposentado(a)",
    value: "APOSENTADO"
  },
  {
    label: "Autônomo(a)",
    value: "AUTONOMO"
  },
  {
    label: "Profissional liberal",
    value: "PROFISSIONAL LIBERAL"
  },
  {
    label: "Sócio(a) Proprietário(a)",
    value: "SOCIO PROPRIETARIO"
  }
]

const AMORTIZATION_SYSTEM_OPTIONS = [
  {
    label: "PRICE",
    value: "PRICE"
  },
  {
    label: "SAC (Sistema de Amortização Constante)",
    value: "SAC"
  }
]

export {
  NATIONALITY_OPTIONS,
  UF_OPTIONS,
  FULL_MARITAL_STATUS_OPTIONS,
  OCCUPATION_CATEGORY_OPTIONS,
  AMORTIZATION_SYSTEM_OPTIONS,
  OCCUPATION_OPTIONS
}
